var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSvg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 682.667 682.667"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Svg_svg__b",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 512h512V0H0Z"
})))), /*#__PURE__*/React.createElement("mask", {
  id: "Svg_svg__a"
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: "100%",
  height: "100%",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m0 0 36.382-103.947L72.244 0h42.313L51.768-182H21.321l-63.7 182z",
  style: {
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1.33333 0 0 -1.33333 269.839 440)"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#Svg_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Svg_svg__b)",
  transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 40,
  d: "M0 0h-91c-22.091 0-40 17.909-40 40v91",
  style: {
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(434.889 360.889)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 40,
  d: "M0 0v230c0 22.092 17.908 40 40 40h195.444l130.445-131.111V0",
  style: {
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(69 222)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 40,
  d: "M0 0c0 39.212 31.764 71 70.946 71 10.278 0 20.042-2.19 28.86-6.124",
  style: {
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(348 91)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 40,
  d: "M0 0h67c0-39.212-31.87-71-71.184-71h.368C-43.13-71-75-39.212-75 0",
  style: {
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(423 91)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 40,
  d: "M0 0h-68.5C-88.106 0-104-15.894-104-35.5S-88.106-71-68.5-71h34C-14.894-71 1-86.894 1-106.5S-14.894-142-34.5-142H-124",
  style: {
    strokeWidth: 40,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(128 162)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m0 0 36.382-103.947L72.244 0h42.313L51.768-182H21.321l-63.7 182z",
  style: {
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(202.379 182)"
}))));
export default SvgSvg;